module.exports = __webpack_public_path__ + "img/zjch.4a6c69ff.png";